const _excluded = ["selected", "onChange", "className", "dateFormat"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import ReactDatePicker from 'react-datepicker';
const MonthPicker = _ref => {
  let {
      selected,
      onChange,
      className,
      dateFormat
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const transformDate = date => {
    if (!date) {
      return null;
    }
    const dateArray = date.split('/');
    if (dateArray.length === 3) {
      return new Date("".concat(dateArray[2], "-").concat(dateArray[1]));
    } else if (dateArray.length === 2) {
      return new Date("".concat(dateArray[1], "-").concat(dateArray[0]));
    }
  };
  const handleDateChange = (date, name) => {
    let formattedDate;
    if (date) {
      formattedDate = "".concat(date.getMonth() + 1, "/").concat(date.getFullYear());
    }
    onChange(formattedDate);
  };
  return /*#__PURE__*/React.createElement(ReactDatePicker, _extends({}, rest, {
    className: className || 'custom-datepicker-input form-control',
    selected: transformDate(selected),
    onChange: date => handleDateChange(date),
    dateFormat: dateFormat || "MM/yyyy",
    showMonthYearPicker: true
  }));
};
export default MonthPicker;